<template functional>
  <div
    class="main-navigation-drawer__item"
    :class="{'main-navigation-drawer__item--selected': props.selected}"
    v-on="listeners"
  >
    <span class="main-navigation-drawer__item__wrap"><slot /></span>
  </div>
</template>

<script>
export default {
  name: 'MainNavigationDrawerItem',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.main-navigation-drawer__item{
  display: flex;
  min-width: 250px;
  height: 48px;
  justify-content: flex-start;
  align-items: center;
  touch-action: manipulation;
  text-rendering: geometricPrecision;
  // Font
  font-family: $font-family-sans-serif-light;
  font-size: 24px;
  line-height: 20px;
  color: $text-muted-color;
  cursor: pointer;

  &--selected{
    color: $black;
    font-family: $font-family-sans-serif-medium
  }

  & + & {
    margin-top: 48px;
  }

  &__wrap {
    border-bottom: solid 1px rgba($black, 0);
    padding: 10px;
    transition: border 0.2s;
  }
  &--selected &__wrap{
      color: #E7873C;
  }
}
</style>
